import { Directive, ElementRef, AfterViewInit } from '@angular/core';
 
@Directive({
  selector: 'ion-input, ion-textarea',
  standalone: true,
})
export class SpellcheckDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}
 
  async ngAfterViewInit() {
    const host = this.el.nativeElement as HTMLElement & { getInputElement?: () => Promise<HTMLElement> };
    // ion-input/ion-textarea render a real <input>/<textarea> in shadow DOM
    const inner = host.getInputElement ? await host.getInputElement() : host;
    if (inner) {
      inner.setAttribute('spellcheck', 'true');
      inner.setAttribute('autocorrect', 'on');
      inner.setAttribute('autocapitalize', 'sentences');
      console.log('spellcheck applied', this.el.nativeElement);
    }
  }
}